// extracted by mini-css-extract-plugin
export default {"item":"CommonCheckBox_item__zMZmm","checkBox":"CommonCheckBox_checkBox__RyWUp","isNotVisible":"CommonCheckBox_isNotVisible__IFbnY","assigned":"CommonCheckBox_assigned__aFQDF"};